import script from "./TressNavigationPill.vue?vue&type=script&setup=true&lang=ts"
export * from "./TressNavigationPill.vue?vue&type=script&setup=true&lang=ts"

import "./TressNavigationPill.vue?vue&type=style&index=0&id=f6f7b104&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6f7b104"]])

export default __exports__